<template>
  <div>
    <div class="login-container">
      <div class="form">
        <div class="login">登录</div>
        <div class="f-list">
          <div class="f-item">
            <div class="f-top">
              <span class="f-icon iconfont icon-shoujihao"></span
              ><span>手机号</span>
            </div>
            <div class="f-bottom">
              <input
                class="f-input"
                placeholder="请输入手机号码"
                type="number"
                maxlength="20"
                v-model="phone"
              />
            </div>
          </div>
          <div class="f-item">
            <div class="f-top">
              <span class="f-icon iconfont icon-yanzhengma"></span
              ><span>验证码</span>
            </div>
            <div class="f-bottom">
              <input
                class="f-input"
                placeholder="请输入验证码"
                type="number"
                maxlength="4"
                v-model="code"
              />
              <div class="line"></div>
              <div class="code" @click="bindSendCode">
                {{ codeTime ? codeTime + 'S' : '获取验证码' }}
              </div>
            </div>
          </div>
        </div>

        <div class="btn" @click="bindLogin">登录</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      phone: '',
      code: '',
      codeTime: ''
    }
  },
  watch: {
    code(val) {
      if (val.length > 4) {
        this.code = val.slice(0, 4)
      }
    }
  },
  mounted() {
    //  this.addShow();
  },
  methods: {
    addShow() {
      window.addEventListener('pageshow', () => {
        this.$toast('1111')
        //  alert("宽高:" + window.screen.width + ',' + window.screen.height);
      })
    },
    checkPhone(phone) {
      if (!phone.length) {
        this.$toast('请输入电话号码')
        return false
      }
      if (phone.length != 11) {
        this.$toast('请检查手机号码长度')
        return false
      }
      return true
    },
    checkCode(code) {
      code = code.trim()
      if (!code) {
        this.$toast('请输入验证码')
      }
      return code
    },
    bindLogin() {
      if (this.disabledSubmit) {
        return
      }
      this.disabledSubmit = true
      if (!this.checkPhone(this.phone)) {
        return
      }
      if (!this.checkCode(this.code)) {
        return
      }
      let params = {
        phone: this.phone,
        identify_code: this.code,
        areaCode: '86'
      }
      this.$http
        .postBaseApp('member/CnaAutoIssued/registerCnaUser', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast('登录成功')
            let token = res.data.data.token
            localStorage.setItem('token', token)
            sessionStorage.setItem('token', token)
            setTimeout(() => {
              let query = Object.assign(
                {
                  phone: this.phone,
                  from_name:
                    res.data.data.s_from_new[this.$route.query.s_from] || ''
                },
                this.$route.query
              )
              this.$router.push({
                path: '/recipe-cna-active',
                query
              })
            }, 500)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch()
        .finally(() => {
          this.disabledSubmit = false
        })
    },
    bindSendCode() {
      if (this.disabledSend) {
        return
      }
      if (!this.checkPhone(this.phone)) {
        return
      }
      this.disabledSend = true
      let params = {
        phone: this.phone,
        areaCode: '86'
      }
      this.$http
        .postBaseApp('sendSms', params)
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.$toast('发送成功')
            this.codeInterval()
          } else {
            this.disabledSend = false
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.disabledSend = false
        })
    },
    codeInterval() {
      this.codeTime = 60
      this.timer = setInterval(() => {
        this.codeTime--
        if (this.codeTime <= 0) {
          this.disabledSend = false
          clearInterval(this.timer)
        }
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
.login-container {
  overflow: hidden;
  width: 100%;
  min-height: 100vh;
  position: relative;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022-11-9-cna-bg');
  background-position: center top;
  background-repeat: no-repeat;
  background-size: 100%;

  .form {
    width: 335px;
    box-sizing: border-box;
    margin: 313px auto 100px;
    background: #ffffff;
    box-shadow: 0px 6px 12px 0px rgba(55, 54, 84, 0.05);
    border-radius: 12px;
    padding: 24px 20px 36px;

    .login {
      margin-bottom: 39px;
      font-size: 22px;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
      font-weight: 600;
      color: #373d52;
      line-height: 25px;
    }

    .f-list {
      margin-bottom: 73px;
    }

    .f-item {
      margin-bottom: 25px;
    }

    .f-item:last-child {
      margin-bottom: 0;
    }

    .f-top {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      margin-bottom: 1px;

      .f-icon {
        font-size: 18px;
        color: rgb(134, 122, 255);
        margin-right: 4px;
      }
    }

    .f-bottom {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f1f1f1;

      .f-input {
        height: 40px;
        flex: 1;
        padding: 0;
        flex-shrink: 0;
        overflow: hidden;
        border: none;
        outline: none;
      }

      .f-input::placeholder {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.3);
        line-height: 20px;
      }

      .line {
        width: 1px;
        height: 10px;
        background: #6338ff;
      }

      .code {
        text-align: center;
        width: 80px;
        box-sizing: border-box;
        padding: 0px 9px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #6338ff;
        line-height: 18px;
      }
    }

    .btn {
      width: 287px;
      margin: 0 auto;
      height: 50px;
      line-height: 50px;
      background: #6759ff;
      border-radius: 25px;
      font-size: 20px;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
      font-weight: 600;
      text-align: center;
      color: #ffffff;
    }
  }
}
</style>
